import AccountNumberInput from '@molecules/AccountNumberInput';
import BPNominalTitle from '@molecules/BPNominalTitle';
import BPPhoneSelection from '@molecules/BPPhoneSelection';
import { showErrorToast } from '@utils/toastManager';
import React from 'react';
import { logRequestBP } from './GGNominals/analyticsNominals';

export function shouldShowPhoneSelection(props: any): JSX.Element | null {
  const { productConfig } = props;
  if (productConfig.hasPhoneChange) {
    return <BPPhoneSelection {...props} />;
  }
  return null;
}

export function shouldShowTitle(props: { nominalTitle?: string }): JSX.Element | null {
  if (props.nominalTitle && props.nominalTitle.length > 0) {
    return <BPNominalTitle nominalTitle={props.nominalTitle} />;
  }
  return null;
}

export function shouldShowAccountInput(props: any): JSX.Element | null {
  const { productConfig } = props;
  if (productConfig.hasAccountInput) {
    return <AccountNumberInput {...props} />;
  }
  return null;
}

export function refetchBPIfStale(isStale: boolean, refetch: () => void): void {
  if (isStale) {
    refetch();
  }
}

export function fetchAvailableProviderFromResponse(
  isSuccess: boolean,
  data: any | null,
  setAvailablePostPaidProvider: (provider: any) => void,
  setShowEmptyView: (show: boolean) => void,
): void {
  if (isSuccess && data) {
    const providerKeys = Object.keys(data);
    if (providerKeys.length > 0) {
      const providers = data[providerKeys[0]];
      const availableProviders = providers.filter((item: any) => item.availability);
      if (availableProviders?.length === 1) {
        setAvailablePostPaidProvider(availableProviders[0]);
      }
      if (availableProviders?.length > 1) {
        setAvailablePostPaidProvider(availableProviders[1]);
      }
    } else {
      setShowEmptyView(true);
    }
  }
}

export function unavailableToast(toast: any, t: (key: string) => string): void {
  return showErrorToast(toast, t('bp.unavailableProduct'), 'unavailableToast');
}

export function withdrawalSuspendedToast(toast: any, t: (key: string) => string): void {
  return showErrorToast(toast, t('common.suspendedError'), 'withdrawalSuspendedToast');
}

export function lockPeriodToast(toast: any, t: (key: string) => string): void {
  return showErrorToast(toast, t('common.lockPeriod'), 'lockPeriodToast');
}

export function disabledButtonForPDAM(selectedAccountNumber: string, selectedPDAMRegion: any): boolean {
  return selectedAccountNumber === '' || selectedPDAMRegion === null;
}

export function getDisabledCheckForTagihanPLN(selectedAccountNumber: string | null, showEmptyView: boolean): boolean {
  if (showEmptyView) return showEmptyView;
  return selectedAccountNumber === null || selectedAccountNumber === '';
}

interface RequestBPParams {
  selectedAccountNumber: string;
  selectedBPAccount: { id: number; amplitudeAccountName: string };
  productApiData: { prefix: string };
  availablePostPaidProvider: { code: string };
  validatedReferralCode: string | null;
  requestBP: (payload: any) => void;
  setAccountInputError: (msg: string) => void;
  t: (key: string) => string;
  productConfig: any;
  source: string;
  meAmplitudeContext: string;
  isFavourite: boolean;
}

export function requestBPForTagihanPLN(tagihanPLNParams: RequestBPParams): () => void {
  const {
    selectedAccountNumber,
    selectedBPAccount,
    productApiData,
    availablePostPaidProvider,
    validatedReferralCode,
    requestBP,
    setAccountInputError,
    t,
    productConfig,
    source,
    meAmplitudeContext,
    isFavourite,
  } = tagihanPLNParams;

  return () => {
    const { amplitudeAccountName } = selectedBPAccount;
    if (selectedAccountNumber) {
      logRequestBP(
        selectedAccountNumber,
        productConfig,
        availablePostPaidProvider,
        source,
        null,
        meAmplitudeContext,
        amplitudeAccountName,
        isFavourite,
      );

      const request = {
        accountNumber: selectedAccountNumber,
        employeeAccountNumber: selectedBPAccount.id,
        transCategoryPrefix: productApiData.prefix,
        productCode: availablePostPaidProvider.code,
        referralCode: validatedReferralCode,
        zoneId: null,
        month: null,
      };
      requestBP(request);
    } else {
      setAccountInputError(t('bp.selectOrInputAccountNumber'));
    }
  };
}
